import { Role } from "../../services";
import createModelStore from "../../utils/createModelStore";

const roles = createModelStore<Role.Model, "roles">("roles");

export default roles;
